import axios from "axios";
import { useState, useEffect } from "react";
import AppLayout from "../../layouts/AppLayout";
import StatCard from "../../components/dashboard/StatCard";
import DemographicsCard from "../../components/dashboard/DemographicsCard";
import ValueChainCard from "../../components/dashboard/ValueChainCard";
import Top5regions from "../../components/dashboard/Top5regions";
import RecentActivityCard from "../../components/dashboard/RecentActivityCard";



const Dashboard = () => {
  const [stats, setStats] = useState({
    totalRegistrations: null,
    completedRegistrations: null,
    registrationDuplicates: null,
    activeToday: null,
    activeThisWeek: null,
  });

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_PUBLIC_API_URL 
    const url = `${baseUrl}/stats`;

    axios.get(url)
      .then(response => {
        const data = response.data.data;
        setStats({
          totalRegistrations: data.total || data.totalRegistrations,
          completedRegistrations: data.completed || data.completedRegistrations,
          registrationDuplicates: data.duplicates || data.registrationDuplicates,
          activeToday: data.active || data.activeToday,
          activeThisWeek: data.activeThisWeek,
        });
      })
      .catch(error => {
        console.error('Error fetching stats:', error);
      });
  
    }, []);


  return (
    <AppLayout>
      <div className="mb-8">
        <h1 className="text-2xl font-semibold mb-1">
          Executive Overview
        </h1>
        <p className="text-gray-600 text-sm">
          Real-time insights from the EYES Ghana Youth Registration Platform
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
        <StatCard
          title="Total Registrations"
          value={stats.totalRegistrations ? stats.totalRegistrations.toLocaleString() : '—'}
          // delta="12.5% + from last week"
          positive
        />
        <StatCard
          title="Completed"
          value={stats.completedRegistrations ? stats.completedRegistrations.toLocaleString() : '—'}
          // delta="8.2+ from last week"
          positive
        />
        <StatCard
          title="Registration Duplicates"
          value={stats.registrationDuplicates ? stats.registrationDuplicates.toLocaleString(): "—"}
          // delta="-3.1% from last week"
          negative
        />
        <StatCard
          title="Active Today"
          value={stats.activeToday ? stats.activeToday.toLocaleString() : '—'}

          // delta="30.2% + from last week"
          positive
        />
        <StatCard
          title="Active This Week"
          value={stats.activeThisWeek ? stats.activeThisWeek.toLocaleString(): "—"}
          // delta="24.6% + from last week"
          positive
        />
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mt-10">
        <DemographicsCard />
        <ValueChainCard />
        <Top5regions />
        <RecentActivityCard />
      </div>
    </AppLayout>
  );
};

export default Dashboard;